import script from "./AnnouncementsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementsTable.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementsTable.vue?vue&type=style&index=0&id=2dd672ee&lang=scss"

const __exports__ = script;

export default __exports__